import { supabase } from '../config/supabase.js'

const PHRASES = [
  n => `There are ${n} fishes in the sky.`,
  n => `${n} lanterns drift through the orchard tonight.`,
  n => `${n} whispers echo between the branches.`,
  n => `${n} moons have risen over this tree.`,
  n => `${n} footsteps trace the old garden path.`,
  n => `${n} stars remember the names.`,
]

let pingPromise = null

export function pingDatabase() {
  if (!pingPromise) {
    pingPromise = supabase.rpc('ping').then(({ data, error }) => {
      if (error) {
        console.warn('Keep-alive ping failed:', error.message)
        return null
      }
      return data
    })
  }
  return pingPromise
}

export function buildCrypticLine(count) {
  if (count == null) return ''
  const phrase = PHRASES[Math.floor(Math.random() * PHRASES.length)]
  return phrase(count)
}

export async function updateCrypticLine(selector = '#cryptic-line') {
  const el = document.querySelector(selector)
  if (!el) return
  const count = await pingDatabase()
  if (count != null) el.textContent = buildCrypticLine(count)
}
